export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SET_USER_ROLE = "SET_USER_ROLE";
export const SET_AUTH_READY = "SET_AUTH_READY";
export const SET_WHITELISTED_ADMIN = "SET_WT_ADMIN";
export const SET_AUTH_BLOCKED = "SET_AUTH_BLOCKED";
export const CLEAR_AUTH_BLOCKED = "CLEAR_AUTH_BLOCKED";

export const setUserRole = (rol: string) => ({
	type: SET_USER_ROLE,
	payload: rol,
});

export const setUser = (name: string, email: string) => ({
	type: SET_USER,
    payload: { name, email }
});

export const clearUser = () => ({
	type: CLEAR_USER,
});

export const setAuthReady = (ready: boolean) => ({
	type: SET_AUTH_READY,
	payload: ready
});

export const setWhitelistedAdmin = (isWhitelisted: boolean) => ({
	type: SET_WHITELISTED_ADMIN,
	payload: isWhitelisted
});

export const setAuthBlocked = (blocked: boolean) => ({
	type: SET_AUTH_BLOCKED,
	payload: blocked
});

export const clearAuthBlocked = () => ({
	type: CLEAR_AUTH_BLOCKED,
});
